import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../../lib/itn-ui-kit/services/service-container";

import Template from "./template";

export default class ClientInfoAvailability extends BaseRoute {
  @service("repositories/case-availability-repository")
  caseAvailabilityRepository;

  element = (<Template />);
  revalidateOnQueryAnyChange = false;
  revalidateOnParams = ["id"];
  revalidateOnQueryKeys = ["client"];

  async loader({ request }) {
    // Get client from URL query params
    const url = new URL(request.url);
    const client = url.searchParams.get("client") || undefined;

    let availabilityData = [];

    if (client) {
      try {
        availabilityData = await this.caseAvailabilityRepository.query({
          user: client,
        });
      } catch (error) {
        console.error("Error fetching availability data:", error);
      }
    }

    return { availabilityData };
  }
}
